// Runtime theme switching. Themes are defined in src/themes.css as sets of
// CSS variables; here we just flip the <html data-theme="..."> attribute and
// remember the choice. Register new themes by adding to THEMES (and adding a
// matching [data-theme="id"] block in themes.css).

export const THEMES = [
  { id: 'default', label: 'Indigo (default)' },
  { id: 'ocean', label: 'Ocean' },
  { id: 'forest', label: 'Forest' },
  { id: 'midnight', label: 'Midnight' },
  { id: 'sunset', label: 'Sunset' },
];

const STORAGE_KEY = 'civicode.theme';

export function getTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'default';
  } catch {
    return 'default';
  }
}

export function applyTheme(id) {
  const root = document.documentElement;
  if (!id || id === 'default') {
    root.removeAttribute('data-theme'); // fall back to :root
  } else {
    root.setAttribute('data-theme', id);
  }
  try {
    localStorage.setItem(STORAGE_KEY, id || 'default');
  } catch {
    /* ignore storage failures (private mode, etc.) */
  }
}

// Call once on app start to restore the saved theme before first paint.
export function initTheme() {
  applyTheme(getTheme());
}
